import { cn } from "@faire/web/tools/cn";
import React from "react";

interface IProps
  extends Omit<
    React.InputHTMLAttributes<HTMLInputElement>,
    "prefix" | "sufix"
  > {
  /**
   * The error message of the input component.
   */
  error?: React.ReactNode;

  /**
   * The container ref (when prefix or suffix is provided).
   */
  containerRef?: React.Ref<HTMLDivElement>;

  /**
   * The prefix of the input component.
   */
  prefix?: React.ReactNode;

  /**
   * The ref of the input component.
   */
  ref?: React.Ref<HTMLInputElement>;

  /**
   * The suffix of the input component.
   */
  suffix?: React.ReactNode;

  /**
   * The function to call when the container is clicked.
   */
  onContainerClick?: () => void;
}

export const InputBase: React.FC<IProps> = ({
  className,
  error,
  onContainerClick,
  prefix,
  suffix,
  containerRef,
  ...props
}) => {
  if (!prefix && !suffix) {
    return (
      <input
        {...props}
        aria-invalid={!!error}
        className={cn("fs-form-field", className)}
      />
    );
  }

  return (
    <div
      className={cn("fs-form-field flex items-center", className)}
      onClick={onContainerClick}
      ref={containerRef}
    >
      {prefix ? (
        <span className="flex items-center pr-(--slate-spacing-element-default)">
          {prefix}
        </span>
      ) : null}
      <input
        {...props}
        aria-invalid={!!error}
        className="w-full focus-visible:outline-none"
      />
      {suffix ? (
        <span className="flex items-center pl-(--slate-spacing-element-default)">
          {suffix}
        </span>
      ) : null}
    </div>
  );
};
